// extracted by mini-css-extract-plugin
export default {"offer-button":"_2wUnx","offerButton":"_2wUnx"};